import { registerBuilderAccordion } from "./__internal__/registerBuilderAccordion";
import { registerBuilderAccordionV2 } from "./__internal__/registerBuilderAccordionV2";
import { registerBuilderAvatar } from "./__internal__/registerBuilderAvatar";
import { registerBuilderButton } from "./__internal__/registerBuilderButton";
import { registerBuilderDottedTooltip } from "./__internal__/registerBuilderDottedTooltip";
import { registerBuilderFoundationIcon } from "./__internal__/registerBuilderFoundationIcon";
import { registerBuilderLayout } from "./__internal__/registerBuilderLayout";
import { registerBuilderRow } from "./__internal__/registerBuilderRow";
import { registerBuilderTabs } from "./__internal__/registerBuilderTabs";
import { registerBuilderTypography } from "./__internal__/registerBuilderTypography";

export const registerBuilderComponents = () => {
  registerBuilderAccordion();
  registerBuilderAccordionV2();
  registerBuilderAvatar();
  registerBuilderButton();
  registerBuilderFoundationIcon();
  registerBuilderLayout();
  registerBuilderRow();
  registerBuilderTabs();
  registerBuilderTypography();
  registerBuilderDottedTooltip();
};
